import { createSlice } from '@reduxjs/toolkit';

/**
 * Window width below which we use mobile view. Note that the wrapping is also
 * dictated by Material UI wrapping the divs, but I can't immediately find where
 * that happens.
 */
const MOBILE_WIDTH = 720;

export interface IViewportState {
  /** Viewport width. */
  width: number;
  /** Value indicating whether to use mobile phone layout. */
  isMobile: boolean;
  /** Value indicating whether a mobile is in landscape orientation. */
  isMobileLandscape: boolean;
}

const currentViewportState = ():IViewportState=>({
  width: window.innerWidth,
  isMobile: window.innerWidth < MOBILE_WIDTH,
  isMobileLandscape: window.innerHeight < MOBILE_WIDTH
})

const initialState: IViewportState = currentViewportState();

export const viewportSlice = createSlice({
  name: 'viewport',
  initialState,
  reducers: {
    updateViewport: (state: IViewportState, action: {}) => {
      const current = currentViewportState();
      state.width = current.width;
      state.isMobile = current.isMobile;
      state.isMobileLandscape = current.isMobileLandscape;
      if (current.isMobile) {
        document.body.setAttribute('is-mobile', 'true');
      } else {
        document.body.removeAttribute('is-mobile');
      }
    }
  }
});

export const { updateViewport } = viewportSlice.actions;
export default viewportSlice.reducer;
